import React from "react";

const StatusBadge = ({ status }) => {
  const variantMap = {
    Active: "team-page__badge team-page__badge--active",
    Pending: "team-page__badge team-page__badge--pending",
    Inactive: "team-page__badge team-page__badge--inactive",
  };

  return <span className={variantMap[status] || "team-page__badge"}>{status}</span>;
};

export default StatusBadge;
